import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  state() {
    return {
        token: null,
    };
  },
  mutations: {
    updateToken(state, value) {
      state.token = value;
    },
    // Autres mutations pour mettre à jour les variables
  },
  plugins: [createPersistedState()],
});

export default store;